import { ArrowRight, MessageCircle } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';
import andy from '../../../assets/images/askAndy.png';

const REGISTER_URL = 'https://app.schoolhack.ai/auth/register';

const AndyBubble = ({ children }) => (
  <div className="flex items-start gap-2">
    <img src={andy} alt="Andy" className="mt-0.5 h-6 w-6 shrink-0 rounded-full object-cover ring-1 ring-accent/40" />
    <div>
      <span className="mb-1 block text-[0.65rem] font-semibold text-white/50">Andy</span>
      <div className="max-w-[16rem] rounded-2xl rounded-tl-sm bg-white/6 px-3 py-2 text-[0.78rem] leading-relaxed text-white/80">
        {children}
      </div>
    </div>
  </div>
);

const ChatCard = () => (
  <div className="card-dark overflow-hidden rounded-2xl">
    <div className="flex items-center gap-2 border-b border-white/8 px-4 py-3">
      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent/15 text-accent">
        <MessageCircle size={13} />
      </span>
      <span className="text-[0.7rem] font-semibold uppercase tracking-wide text-white">
        Chat with Andy
      </span>
    </div>
    <div className="flex flex-col gap-3 p-4">
      <AndyBubble>Hey! I&apos;ve read your Biology notes. Ready to help you nail your exam 🎓</AndyBubble>
      <div className="ml-auto max-w-[15rem] rounded-2xl rounded-tr-sm bg-accent/15 px-3 py-2 text-[0.78rem] text-white">
        Can you explain what telophase is?
      </div>
      <AndyBubble>
        Sure! Telophase is the final stage of mitosis where the chromosomes reach the
        opposite poles and the nuclear envelope reforms around each set. Think of it as
        the cell &quot;resetting&quot; — two new nuclei form, getting ready to split! 🧬
      </AndyBubble>
    </div>
  </div>
);

const Hero = () => {
  return (
    <section className="relative overflow-hidden pb-16 pt-14 md:pt-48 lg:pb-24">
      <div className="glow left-1/2 top-[-140px] h-[420px] w-[620px] -translate-x-1/2 bg-accent/16" />
      <div className="glow right-[-120px] top-[120px] h-[360px] w-[360px] bg-accent/10" />
      <div className="pointer-events-none absolute inset-0 grid-overlay opacity-60" />

      <Container className="relative grid items-center gap-12 lg:grid-cols-[1.05fr_1fr]">
        {/* copy */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <Reveal>
            <span className="eyebrow">Interactive Teacher — Andy</span>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="font-heading mt-6 text-[2.2rem] font-bold leading-[1.08] sm:text-[2.9rem] lg:text-[3.3rem]">
              <span className="head-fade">Your Personal Tutor.</span>
              <br />
              <span className="text-accent-grad">Available 24/7.</span>
              <br />
              <span className="head-fade">Knows Your Notes.</span>
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="mx-auto mt-6 w-full max-w-[32rem] text-[0.98rem] leading-relaxed text-white/60 lg:mx-0">
              Andy is School Hack&apos;s AI teacher — built directly into your study
              set. He reads your notes, understands your material, and answers every
              question you have in plain English. No waiting, no judgment, no office
              hours.
            </p>
          </Reveal>
          <Reveal delay={240}>
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-8 px-7 py-3.5 text-[0.95rem]"
            >
              Meet Andy
              <ArrowRight size={17} />
            </a>
          </Reveal>
        </div>

        {/* chat card */}
        <Reveal delay={200} className="relative mx-auto w-full max-w-[420px]">
          <div className="glow left-1/2 top-1/2 h-[320px] w-[340px] -translate-x-1/2 -translate-y-1/2 bg-accent/14" />
          <div className="relative animate-float-slow">
            <ChatCard />
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default Hero;
